import { clientId } from "./constants";
import "./appLinks";

export const productsRoutes = [
  {
    path: "/products",
    name: "products",
    component: () => import("@shared/products/views/ProductsTypeSelection.vue"),
    meta: {
      appClientId: clientId,
      breadcrumbs: [
        {
          label: "products",
          route: { name: "products" },
        },
      ],
    },
  },
  {
    path: "/products/:template",
    name: "productsList",
    props: true,
    component: () =>
      import("@shared/products/views/ProductsManagementListView.vue"),
    meta: {
      appClientId: clientId,
      breadcrumbs: [
        {
          label: "products",
          route: { name: "products" },
        },
      ],
    },
  },
  {
    path: "/products/:template/edit/:id?",
    name: "productsDetail",
    props: true,
    component: () =>
      import("@shared/products/views/ProductsManagementDetailView.vue"),
    meta: {
      appClientId: clientId,
      breadcrumbs: [
        {
          label: "products",
          route: { name: "products" },
        },
      ],
    },
  },
];
